// 绘制经纬度网格功能

// const entitiesMarketList = []
// addGrid()
let _marketList = []

let isGridAdd = false
// 添加经纬度网格
function addLonLatGird (self) {
  self = self || this
  const viewer = self.viewer
  const entities = viewer.entities
  // 判断是否抗锯齿
  if (Cesium.FeatureDetection.supportsImageRenderingPixelated()) {
    // 判断是否支持图像渲染像素化处理
    viewer.resolutionScale = window.devicePixelRatio
  }
  // 开启抗锯齿
  viewer.scene.fxaa = true
  viewer.scene.postProcessStages.fxaa.enabled = true
  if (isGridAdd) {
    return
  }
  isGridAdd = true
  // const _material = Cesium.Color.GREY
  // 经纬度网格颜色
  const materialStyle = new Cesium.PolylineDashMaterialProperty({
    color: Cesium.Color.WHITE
  })
  const marketlist = []
  // 每隔20读绘制一条经度线和经度标注,自己控制间隔
  for (let lang = -180; lang <= 180; lang += 20) {
    let text = ''
    if (lang === 0) {
      text = '0'
    }
    text += lang === 0 ? '' : '' + lang + '°'
    if (lang === -180) {
      text = ''
    }
    const market = entities.add({
      position: Cesium.Cartesian3.fromDegrees(lang, 0),
      polyline: {
        positions: Cesium.Cartesian3.fromDegreesArray([lang, -89.9, lang, 0, lang, 89.9]),
        width: 1.0,
        material: materialStyle
      },
      label: {
        text: text,
        verticalOrigin: Cesium.VerticalOrigin.TOP,
        font: '12px sans-serif',
        fillColor: Cesium.Color.WHITE
      }
    })
    marketlist.push(market)
  }

  const langS = []
  for (let lang = -180; lang <= 180; lang += 5) {
    langS.push(lang)
  }

  // 纬度粒度
  // 每隔10读绘制一条纬度线和纬度标注,自己控制间隔
  for (let lat = -80; lat <= 80; lat += 20) {
    let text = ''
    text += '' + lat + '°'
    if (lat === 0) {
      text = ''
    }
    const market = entities.add({
      position: Cesium.Cartesian3.fromDegrees(0, lat),
      polyline: {
        positions: Cesium.Cartesian3.fromDegreesArray(
          langS
            .map((long) => {
              return [long, lat].join(',')
            })
            .join(',')
            .split(',')
            .map((item) => Number(item))
        ),
        width: 1.0,
        material: materialStyle
      },
      label: {
        text: text,
        font: '12px sans-serif',
        fillColor: Cesium.Color.WHITE
      }
    })
    marketlist.push(market)
  }

  _marketList = marketlist
}

function removeLonLatGird (self) {
  self = self || this
  const viewer = self.viewer
  const entities = viewer.entities
  _marketList.forEach(_market => {
    entities.remove(_market)
  })
  _marketList = []
  isGridAdd = false
}

export { addLonLatGird, removeLonLatGird }
